import React from 'react'
import { isRequired } from '../../../eyeMedHelper'
import { Field, formValueSelector } from 'redux-form'
import { humanize } from '../../../../../../../../../../itrust_common/components/HelperFunctions'
import { Checkbox, Input, Select, Textarea } from '../../../../../../../../../../itrust_common/components/form'
import { connect } from 'react-redux'

function FrameFormFields(props) {
  const { frameFields = [], frameAttestationValue } = props

  const RenderFields = (props) => {
    const { field } = props

    switch (field.type) {
      case "dropdown":
        return <Field
          name={`${field.label}.value`}
          label={`${humanize(field.label)}`}
          component={Select}
          tooltipClasses="text-wrap"
          data={field.options}
          textField="label"
          valueField="label"
          validate={[...isRequired(field)]}
          wrapperClasses={`form-group mb-8 exam-auto-select col-6`}
        />

      case "checkbox":
        return <Field
          component={Checkbox}
          name={`${field.label}`}
          className="form-control"
          wrapperClasses="form-group col-6 mt-6"
          label={`${humanize(field.label)}`}
          validate={[...isRequired(field)]}
        />
      case "text_area":
        if (field.label === "please_explain(other)") {
          return frameAttestationValue === "Other"
            ? <Field
              name={`${field.label}`}
              label={`${humanize(field.label)}`}
              component={Textarea}
              className="form-control"
              wrapperClasses="form-group col-6"
              validate={[...isRequired(field)]}
            />
            : null
        }
        return <Field
          name={`${field.label}`}
          label={`${humanize(field.label)}`}
          component={Textarea}
          className="form-control"
          wrapperClasses="form-group col-6"
          validate={[...isRequired(field)]}
        />
      default:
        return <Field name={`${field.label}`} label={`${humanize(field.label)}`} component={Input} className="form-control" wrapperClasses="form-group col-6" validate={[...isRequired(field)]} />
    }
  }

  return (
    <>
      {frameFields?.map(field => <RenderFields field={field} key={field.label} />)}
    </>
  )
}
const selector = formValueSelector('EyeMedClaimForm')

const mapStateToProps = (state) => {
  const { } = state
  return {
    frameAttestationValue: selector(state, 'frames.frame_attestation.value')
  }
}

export default connect(mapStateToProps)(FrameFormFields);